if (!customElements.get('meyspring-palette-builder')) {
  customElements.define('meyspring-palette-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = JSON.parse(this.querySelector('[data-builder-messages]').textContent);
      this.cards = [...this.querySelectorAll('[data-pigment]')];
      this.submit = this.querySelector('[data-builder-submit]');
      this.search = this.querySelector('[data-builder-search]');
      this.filter = 'all';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency});
      const params = new URL(window.location.href).searchParams;
      const initial = new Map();
      (params.get('colors') || '').split(',').filter(Boolean).forEach(handle => initial.set(handle, 1));
      (params.get('quantities') || '').split(',').forEach(item => {
        const [handle, value] = item.split(':');
        if (/^\d+$/.test(value || '') && Number(value) > 0) initial.set(handle, Number(value));
      });
      this.cards.forEach(card => {
        const input = card.querySelector('input');
        input.value = String(this.normalize(card, initial.get(card.dataset.handle) || 0));
        card.querySelector('[data-increase]').addEventListener('click', () => this.change(card, Number(input.value) + 1));
        card.querySelector('[data-decrease]').addEventListener('click', () => this.change(card, Number(input.value) - 1));
        input.addEventListener('input', () => this.change(card, Number(input.value)));
        input.addEventListener('change', () => this.change(card, Number(input.value)));
      });
      this.search.addEventListener('input', () => this.filterCards());
      this.querySelectorAll('[data-builder-filter]').forEach(button => button.addEventListener('click', () => {
        this.filter = button.dataset.builderFilter;
        this.querySelectorAll('[data-builder-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.filterCards();
      }));
      this.querySelector('[data-selected-list]').addEventListener('click', event => {
        const button = event.target.closest('[data-remove-pigment]');
        if (!button || this.busy || this.finished) return;
        const card = this.cards.find(item => item.dataset.id === button.dataset.removePigment);
        this.change(card, 0);
        const next = this.querySelector('[data-remove-pigment]');
        if (next) next.focus(); else this.querySelector('[data-selection-toggle]').focus();
      });
      this.querySelector('[data-selection]').open = window.matchMedia('(min-width:990px)').matches;
      this.submit.addEventListener('click', () => this.addToCart());
      this.filterCards();
      this.update(false);
    }
    normalize(card, quantity) {
      if (card.dataset.available !== 'true') return 0;
      const maximum = card.dataset.max === '' ? Number.MAX_SAFE_INTEGER : Number(card.dataset.max);
      return Math.min(maximum, Math.max(0, Number.isFinite(quantity) ? Math.floor(quantity) : 0));
    }
    change(card, quantity) {
      if (this.busy || this.finished) return;
      card.querySelector('input').value = String(this.normalize(card, quantity));
      this.update(true);
    }
    filterCards() {
      const term = this.search.value.trim().toLowerCase();
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = !((this.filter === 'all' || card.dataset.kind === this.filter) && card.dataset.title.toLowerCase().includes(term));
        if (!card.hidden) count++;
      });
      this.querySelector('[data-builder-results]').textContent = this.messages.results.replace('[count]', count);
      this.querySelector('[data-no-results]').hidden = count > 0;
    }
    update(save) {
      const chosen = this.cards.filter(card => Number(card.querySelector('input').value) > 0);
      const quantity = chosen.reduce((sum, card) => sum + Number(card.querySelector('input').value), 0);
      this.quantity = quantity;
      const subtotal = chosen.reduce((sum, card) => sum + Number(card.dataset.price) * Number(card.querySelector('input').value), 0);
      const discounted = chosen.reduce((sum, card) => sum + Math.round(Number(card.dataset.price) * Number(card.querySelector('input').value) * .8), 0);
      this.cards.forEach(card => {
        const input = card.querySelector('input'), amount = Number(input.value);
        card.classList.toggle('is-selected', amount > 0);
        card.querySelector('[data-decrease]').disabled = this.busy || this.finished || amount === 0;
        card.querySelector('[data-increase]').disabled = this.busy || this.finished || card.dataset.available !== 'true' || (card.dataset.max !== '' && amount >= Number(card.dataset.max));
        input.disabled = this.busy || this.finished || card.dataset.available !== 'true';
      });
      this.querySelector('[data-jar-count]').textContent = (quantity === 1 ? this.messages.one_jar : this.messages.jar_count).replace('[count]', quantity);
      const status = this.querySelector('[data-builder-status]');
      status.textContent = quantity >= 4 ? this.messages.unlocked : quantity === 3 ? this.messages.remaining_one : this.messages.remaining.replace('[count]', 4 - quantity);
      status.classList.toggle('is-ready', quantity >= 4);
      this.querySelector('[data-builder-total]').textContent = this.money.format((quantity >= 4 ? discounted : subtotal) / 100);
      const original = this.querySelector('[data-builder-original]');
      original.textContent = quantity >= 4 ? this.money.format(subtotal / 100) : '';
      original.hidden = quantity < 4;
      this.querySelector('[data-builder-total]').classList.toggle('is-discounted', quantity >= 4);
      this.submit.disabled = quantity < 4 || this.busy;
      this.submit.textContent = quantity >= 4 ? this.messages.add : this.messages.choose;
      const list = this.querySelector('[data-selected-list]');
      list.replaceChildren();
      chosen.forEach(card => {
        const row = document.createElement('li');
        const name = document.createElement('span');
        name.textContent = card.dataset.title + ' × ' + card.querySelector('input').value;
        const remove = document.createElement('button');
        remove.type = 'button'; remove.textContent = '×'; remove.dataset.removePigment = card.dataset.id;
        remove.setAttribute('aria-label', this.messages.remove.replace('[title]', card.dataset.title));
        row.append(name, remove); list.append(row);
      });
      this.querySelector('[data-empty-selection]').hidden = chosen.length > 0;
      if (save && window.location.protocol !== 'about:') {
        const url = new URL(window.location.href);
        url.searchParams.delete('colors');
        if (chosen.length) url.searchParams.set('quantities', chosen.map(card => card.dataset.handle + ':' + card.querySelector('input').value).join(','));
        else url.searchParams.delete('quantities');
        window.history.replaceState(null, '', url);
      }
    }
    cartDestination() {
      const root = window.Shopify?.routes?.root || this.dataset.root;
      const destination = new URL(root + 'discount/' + encodeURIComponent(this.dataset.code), window.location.origin);
      destination.searchParams.set('redirect', this.dataset.cart);
      return destination.href;
    }
    async addToCart() {
      if (this.finished) { window.location.assign(this.cartDestination()); return; }
      if (this.busy || this.quantity < 4) return;
      this.busy = true; this.setAttribute('aria-busy', 'true'); this.update(false);
      this.submit.textContent = this.messages.adding;
      try {
        const root = window.Shopify?.routes?.root || this.dataset.root;
        const items = this.cards.filter(card => Number(card.querySelector('input').value) > 0).map(card => ({id:Number(card.dataset.id), quantity:Number(card.querySelector('input').value)}));
        const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('Cart update not confirmed');
        this.finished = true;
        window.location.assign(this.cartDestination());
      } catch {
        this.finished = true;
        const error = this.querySelector('[data-builder-error]');
        error.textContent = this.messages.error; error.hidden = false;
        this.submit.textContent = this.messages.view_cart; this.submit.disabled = false;
      } finally {
        this.busy = false; this.removeAttribute('aria-busy');
      }
    }
  });
}

